<template>
  <div id="app">
  <iiifannotation annotationlist="http://0.0.0.0:5555/annotate/annotations/00005555-spencer-davis-7zpvoe2psxm-unsplash-list.json"></iiifannotation>
  <multistoryboard annotationlists='https://ncsu-libraries.github.io/iiif-annotation/webannotations/mc00084-001-te0159-000-001-0001-list.json;https://ncsu-libraries.github.io/iiif-annotation/webannotations/ua023-015-003-bx0002-004-026-list.json' styling='annoview: sidebyside;'></multistoryboard>
  <storyboard annotationlist='https://dnoneill.github.io/annotate/annotations/131424-list.json' layers='[{"label":"<a href=\"https://www.wikidata.org/wiki/Q4792194\">View from Arles</a>","xywh":"200,200,4700,6100","image":"https://tools.wmflabs.org/zoomviewer/iipsrv.fcgi/?iiif=cache/8937e1777945b722457fac2cde0cf61b.tif/info.json","section":"","rotation":""}]'></storyboard>
  <storyboard annotationlist='https://dnoneill.github.io/annotate/annotations/wh234bz9013-0001-list.json' styling='tagscolor: {"animals":"#e124c9"," historical":"#1759f5"};'></storyboard>
  <storyboard annotationlist='https://ncsu-libraries.github.io/iiif-annotation/webannotations/mc00084-001-te0159-000-001-0001-list.json' styling="annoview: sidebyside"></storyboard>
</div></template>

<script>
import iiifannotation from './components/iiifannotation.vue'
import storyboard from './components/storyboard.vue'
import multistoryboard from './components/multistoryboard.vue'
import rangestoryboard from './components/rangestoryboard.vue'
export default {
  name: 'app',
  data: function() {
    return {
      data: ''
    }
  },
  components: {
    iiifannotation,
    storyboard,
    multistoryboard,
    rangestoryboard
  }
}
</script>
